import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-nav-menu-item',
    templateUrl: './nav-menu-item.component.html',
    styleUrls: ['./nav-menu-item.component.sass'],
    standalone: false
})

export class NavMenuItemComponent {

  @Input() title: string = '';
  @Input() link: string = '/';
  @Input() icon: string = '';
  @Input() color: string = '';
  @Input() width: string = 'w-[19rem]';

}